import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import AuthInfo from "../AuthInfo";

const AuthWrapper = ({
    isAuthError, showErrorPage, isAuthenticated, isAuthenticating, logOut,
}) => (
    <>
        <Snackbar
            open={isAuthError}
            autoHideDuration={1000}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
            }}
        >
            <MuiAlert elevation={6} variant="filled" severity="error">
                Unable to authenticate into AD or Middleware
            </MuiAlert>
        </Snackbar>
        <AuthInfo
            displayError={
                showErrorPage || (!isAuthenticated && !isAuthenticating)
            }
            logOut={logOut}
        />
    </>
);

export default AuthWrapper;
